/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useContext } from 'react';
import './main.css';
import UnifiedEpoListLoads from './EpoListLoads/UnifiedEpoListLoads';
import { StoreContext } from './Store';

const ListUnifiedEpoLoads = () => {
  const [requestFailed, setRequestFailed] = useState(false);
  const store = useContext(StoreContext);

  useEffect(() => {
    async function fetchData() {
      try {
        store.resetNewLoad();
      } catch (err) {
        setRequestFailed(true);
      }
    }
    fetchData();
  }, []);

  if (requestFailed) return <p>Failed!</p>;

  return (
    <div className="main">
      <section>
        <UnifiedEpoListLoads />
      </section>
    </div>
  );
};

export default ListUnifiedEpoLoads;
